
















































import { Component, Prop, Vue } from "vue-property-decorator";
import { BARTHEL_FIELDS, BarthelField, OpsiSkor } from "@/constants/geriatriOptions";
import { BarthelBlock, BarthelKey } from "@/types/asesmen_geriatri";

@Component
export default class BarthelIndexInput extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: BarthelBlock;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  get fields(): BarthelField[] {
    return BARTHEL_FIELDS;
  }

  labelOpsi(opsi: OpsiSkor): string {
    return `${opsi.value} (${opsi.text})`;
  }

  terisi(key: BarthelKey): boolean {
    const nilai = this.value[key] as unknown;
    return nilai !== null && nilai !== undefined && nilai !== "";
  }

  setNilai(key: BarthelKey, nilai: number | null) {
    this.$set(this.value, key, nilai === undefined ? null : nilai);
    this.$emit("input", this.value);
  }
}
